export default "__VITE_ASSET__6cabbe78__$_?component__"